import { useDispatch } from "react-redux";
import React, { useState } from "react";
import { Button } from "reactstrap";
import InputField from "../../../../components/Custom/Forms/InputField/InputField";
import {
    camelToTitleCase,
    isOnlyNumbers,
    responseToaster,
    seperator,
} from "../../../../helperFunctions";
import {
    merchantLevelRoasterUpdate,
    setMerchantLevelRoaster,
    useMerchantRoasterLevel,
} from "../../../../redux/slices/merchantSlice";
import Loader from "../../../../components/Custom/Loader";
import { showToaster } from "../../../../constant";

const UpdateRoasters = (props) => {
    const { data, dataKey } = props;

    const dispatch = useDispatch();
    const [updateDetails, setUpdateDetails] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const roasterData = useMerchantRoasterLevel();

    const onUpdate = async (e) => {
        try {
            e.preventDefault();
            const payload = {
                ...data,
                [dataKey]: updateDetails?.value,
            };

            if (!payload?.[dataKey]?.length && payload?.[dataKey] !== 0) {
                showToaster("Please Enter Value", "Error");
                return;
            }

            if (payload?.[dataKey] == 0) {
                showToaster("Please enter a value other than 0.", "Error");
                return;
            }

            if (dataKey === "amountFrom" && +data?.amountTo <= payload?.[dataKey]) {
                showToaster(
                    "The 'From Amount' must be less than the 'To Amount'.",
                    "Error"
                );
                return;
            }

            if (dataKey === "amountTo" && +data?.amountFrom >= payload?.[dataKey]) {
                showToaster(
                    "The 'To Amount' must be greater than the 'From Amount'.",
                    "Error"
                );
                return;
            }

            if (
                dataKey === "withdrawalAmtFrom" &&
                +data?.withdrawalAmtTo <= payload?.[dataKey]
            ) {
                showToaster(
                    "The 'From Amount' must be less than the 'Withdrawal To Amount'.",
                    "Error"
                );
                return;
            }

            if (
                dataKey === "withdrawalAmtTo" &&
                +data?.withdrawalAmtFrom >= payload?.[dataKey]
            ) {
                showToaster(
                    "The 'To Amount' must be greater than the 'Withdrawal From Amount'.",
                    "Error"
                );
                return;
            }
            setIsLoading(true);
            const { isActive, isOpen, ...rest } = payload;
            const res = await dispatch(merchantLevelRoasterUpdate(rest)).unwrap();
            responseToaster(res);
            const index = roasterData?.data?.findIndex?.(
                (item) => item?.id === data?.id
            );
            if (index > -1) {
                const newData = [...roasterData?.data];
                newData[index] = { ...newData[index], [dataKey]: updateDetails?.value };

                dispatch(
                    setMerchantLevelRoaster({
                        ...roasterData?.data,
                        data: newData,
                    })
                );
            }
            setUpdateDetails({});
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
        }
    };
    
    return (
        <>
            <div className={`${data?.isOpen ? "cell-order-white" : "cell-order"}`}>
                <div className="order-singal-div">
                    <div>
                        {updateDetails?.id === data?.id &&
                            updateDetails?.name === data?.name &&
                            data?.id ? (
                            <form className="d-flex tableinput" onSubmit={onUpdate}>
                                <InputField
                                    autoFocus
                                    id={dataKey}
                                    value={updateDetails?.value}
                                    disabled={isLoading}
                                    placeholder={`Enter ${camelToTitleCase(dataKey)}`}
                                    onChange={(e) => {
                                        if (
                                            isOnlyNumbers(e.target.value) ||
                                            e.target.value === ""
                                        ) {
                                            setUpdateDetails({
                                                ...updateDetails,
                                                value: e.target.value,
                                            });
                                        }
                                    }}
                                />
                                <Button
                                    type="submit"
                                    color="primary"
                                    className="btn-smallsize"
                                    onClick={onUpdate}
                                >
                                    {isLoading ? (
                                        <Loader />
                                    ) : (
                                        <i className="fa-solid fa-check"></i>
                                    )}
                                </Button>
                                <Button
                                    color="danger"
                                    className="btn-smallsize"
                                    onClick={() => setUpdateDetails({})}
                                >
                                    <i className="fa-solid fa-xmark"></i>
                                </Button>
                            </form>
                        ) : (
                            <span
                                className="cursor-pointer"
                                style={{ color: "var(--chatlook-darkblue--)" }}
                                onClick={() => {
                                    setUpdateDetails({
                                        id: data?.id,
                                        value: data?.[dataKey],
                                        name: data?.name,
                                    });
                                }}
                            >
                                {`${seperator(
                                    +data?.[dataKey],
                                    !["depositCount", "withdrawalCount"]?.includes(dataKey)
                                )}`}
                            </span>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default UpdateRoasters;
